import React, {createContext, useContext} from 'react'
import {CardTypeEnum} from '@colonist/game-states'
import {GameModeTranslationKeyContext} from '@colonist/i18n'
import {BaseGameModeData} from '@colonist/shared-types'

interface UIGameModeContextProps {
    activeResourceCardTypes: CardTypeEnum[]
    activeDevelopmentAndProgressCardTypes: CardTypeEnum[]
    translationKeyContext: GameModeTranslationKeyContext
}

const UIGameModeContext = createContext<UIGameModeContextProps | undefined>(undefined)

export const useUIGameModeContext = () => {
    const context = useContext(UIGameModeContext)
    if(!context) throw new Error('UIGameModeContext not found')
    return context
}

interface UIGameModeProviderProps {
    gameModeData: BaseGameModeData
    children: React.ReactNode
}

export const UIGameModeProvider = ({
    gameModeData,
    children,
}: UIGameModeProviderProps) => {
    const {activeDevelopmentCardTypes, activeResourceCardTypes, translationKeyContext} = gameModeData

    return <UIGameModeContext.Provider value={{
        activeResourceCardTypes: activeResourceCardTypes,
        activeDevelopmentAndProgressCardTypes: activeDevelopmentCardTypes,
        translationKeyContext: translationKeyContext,
    }}>
        {children}
    </UIGameModeContext.Provider>
}
